import { SearchInput, Text } from '@billy/design-system'
import React, { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from '../../styles'
import { NotMappedToPublicChartOfAccountsTag } from '../NotMappedToPublicChartOfAccountsTag'

interface ChartOfAccountsNavigatorProps {
  accountsCount?: number
  onArchivedChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onClear?: () => void
  onQueryChange?: (event: ChangeEvent<HTMLInputElement>) => void
  value?: string
}

export const ChartOfAccountsNavigator = ({
  accountsCount = 0,
  onArchivedChange = () => null,
  onClear = () => null,
  onQueryChange = () => null,
  value,
}: ChartOfAccountsNavigatorProps) => {
  const { t } = useTranslation()

  return (
    <Styled.Navigator>
      <Styled.NavigationItem>
        <NotMappedToPublicChartOfAccountsTag />
      </Styled.NavigationItem>
      <Styled.NavigationItem>
        <Text>{t('coa.accounts.count', { count: accountsCount })}</Text>
      </Styled.NavigationItem>
      <Styled.NavigationItem>
        <Styled.FilterCheckbox label={t('coa.show_archived')} onChange={onArchivedChange} />
      </Styled.NavigationItem>
      <Styled.NavigationItem>
        <SearchInput value={value} onChange={onQueryChange} onClear={onClear} placeholder={`${t('search')}...`} />
      </Styled.NavigationItem>
    </Styled.Navigator>
  )
}
